export default __webpack_public_path__ + "static/sygnet-fdb01af92f83c8f0f59c38fab30f07fa.svg";